import React, { useEffect, useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputNumber } from "primereact/inputnumber";
import OrderItemsSubTable1 from "./items/OrderItemsSubTable1";

import {
  isSunDistribution,
  convertToTwoDecimals,
} from "../../../shared/utility";

export default function OrderItemsForShippingV2(props) {
  const {
    askDeleteShippingItem,
    order,
    openQuickScanPopupWithFetchLatest,
    rowDetails,
    fetchRowDetails,
    loadingRows,
    printShippingLabel,
    updateOrderItemUnitCost,
    setOrderItems,
  } = props;

  const [expandedRows, setExpandedRows] = useState(null);
  const [isSunDistributionFlow, setIsSunDistributionFlow] = useState(false);

  const allowExpansion = (rowData) => {
    const shippingItems = rowData.shippingItems ? rowData.shippingItems : [];
    // return shippingItems.length > 0;
    return true;
  };

  const onRowExpand = (event) => {
    const rowData = event.data;
    if (!rowDetails[rowData.id]) {
      fetchRowDetails(rowData);
    }
  };

  useEffect(() => {
    setExpandedRows(null);
  }, [order.orderItems]);

  useEffect(() => {
    setIsSunDistributionFlow(isSunDistribution());
  }, []);

  const productDetailsBody = (rowData) => {
    return (
      <p>
        <span className="text-gray-900 font-semibold">
          {rowData.product_name}
        </span>
        <br />
        <span className="text-gray-700">PLU:{rowData.plu}</span>
      </p>
    );
  };

  const orderQuantityBody = (rowData) => {
    return (
      <p>
        {rowData.quantity} {rowData.selling_unit_of_measure}
      </p>
    );
  };

  const shippedQuantity = (rowData) => {
    return (
      <p>
        {rowData.shipped_amount} {rowData.selling_unit_of_measure}
      </p>
    );
  };

  const unitPriceBody = (rowData) => {
    if (rowData.unit_price === null) return <p>0.00</p>;
    return <p>${rowData.unit_price}</p>;
  };

  const totalPriceBody = (rowData) => {
    if (rowData.total_order_shipped_amount === null) return <p>0.00</p>;
    return <p>${rowData.total_order_shipped_amount}</p>;
  };

  const actionTemplate = (rowData) => {
    if (!isSunDistributionFlow) return null;

    return (
      <button
        type="button"
        className="inline-flex items-center justify-center rounded-lg bg-teal-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition-all duration-200 hover:bg-teal-700 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600"
        onClick={() => printShippingLabel(rowData.id)}
      >
        Shipping Label
      </button>
    );
  };

  const rowExpansionTemplate = (data) => {
    return (
      <OrderItemsSubTable1
        askDeleteShippingItem={askDeleteShippingItem}
        data={data}
        loadingRows={loadingRows}
        rowDetails={rowDetails}
        openQuickScanPopupWithFetchLatest={openQuickScanPopupWithFetchLatest}
      />
    );
  };

  const onRowEditComplete = async (e) => {
    const { newData, index } = e;
    const orderItemId = newData.id;
    const unitPrice = newData.unit_price;

    // Only update if unit_price has changed
    const currentItem = order.orderItems[index];

    if (currentItem && currentItem.unit_price === unitPrice) {
      return; // No change, skip API call
    }

    // Call API to update unit price
    const callResult = await updateOrderItemUnitCost(orderItemId, unitPrice);

    if (callResult && callResult.success) {
      // Update the order.orderItems array with the returned data
      const updatedOrderItems = [...order.orderItems];
      const returnedData = callResult.data;

      updatedOrderItems[index] = {
        ...currentItem,
        ...returnedData,
      };

      setOrderItems(updatedOrderItems);
    }
    // Error handling is done in the ViewModel function
  };

  const priceEditor = (options) => {
    return (
      <InputNumber
        value={options.value}
        onValueChange={(e) => options.editorCallback(e.value)}
        mode="currency"
        currency="USD"
        locale="en-US"
      />
    );
  };

  return (
    <div className="mt-5 flow-root">
      <div className="sm:-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="overflow-hidden">
            <DataTable
              value={order.orderItems}
              expandedRows={expandedRows}
              onRowToggle={(e) => {
                setExpandedRows(e.data);
              }}
              onRowExpand={onRowExpand}
              rowExpansionTemplate={rowExpansionTemplate}
              editMode="row"
              onRowEditComplete={onRowEditComplete}
              dataKey="id"
              tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm wip-incoming-items-table"
              cellClassName="p-2 border-1-bottom-gray text-sm"
            >
              <Column
                header="Product"
                body={productDetailsBody}
                style={{ width: "40%" }}
              />
              <Column
                header="Order qty/Cs"
                body={orderQuantityBody}
                style={{ width: "15%" }}
              />
              <Column
                header="Shipped qty"
                body={shippedQuantity}
                style={{ width: "15%" }}
              />
              {isSunDistributionFlow && (
                <Column
                  field="unit_price"
                  header="Unit price"
                  body={unitPriceBody}
                  editor={(options) => priceEditor(options)}
                  style={{ width: "15%" }}
                />
              )}
              {isSunDistributionFlow && (
                <Column
                  header="Total price"
                  body={totalPriceBody}
                  style={{ width: "15%" }}
                />
              )}
              <Column
                header=""
                body={actionTemplate}
                style={{ width: "10%" }}
              />
              {isSunDistributionFlow && (
                <Column
                  rowEditor={true}
                  headerStyle={{ width: "10%", minWidth: "8rem" }}
                  bodyStyle={{ textAlign: "center" }}
                ></Column>
              )}
              <Column expander={allowExpansion} style={{ width: "5rem" }} />
            </DataTable>
          </div>
        </div>
      </div>
      {isSunDistributionFlow && (
        <div className="mt-6 flex justify-end">
          <div className="w-full max-w-sm">
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-md font-medium text-gray-600">
                  Subtotal:
                </span>
                <span className="text-md font-semibold text-gray-900">
                  ${order.shipped_subtotal_dollar_amount}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-md font-medium text-gray-600">Tax:</span>
                <span className="text-md font-semibold text-gray-900">
                  $0.00
                </span>
              </div>
              <div className="border-t border-gray-300 pt-2 mt-2">
                <div className="flex justify-between items-center">
                  <span className="text-lg font-bold text-gray-900">
                    Total:
                  </span>
                  <span className="text-lg font-bold text-gray-900">
                    ${order.shipped_total_dollar_amount}
                  </span>
                </div>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-lg font-bold text-gray-900">
                  Total Cartons:
                </span>
                <span className="text-lg font-bold text-gray-900">
                  {order.total_shipped_cartons}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
